import React from "react";
import { Form, Container, Row, Col } from "react-bootstrap";
import { AiFillMail } from "react-icons/ai";
import { GoLocation } from "react-icons/go";
import { BsTelephoneFill } from "react-icons/bs";
import ContactBox from "../../components/ContactBox";
const Contact = () => {
  return (
    <>
      <div className="contact">
        <Container>
          <p className="contact__us">contact us</p>
          <h1>drop us a line</h1>
          <p className="contact__desc">
            Fill out the form below and we will get back to you shortly. Also,
            feel free to call us or email us anytime.
          </p>
          <div className="contact__detail">
            <div>
              <AiFillMail className="icon" />
              <span className="ms-3">hotelpauwabutwal@gmail.com</span>
            </div>
            <div>
              <GoLocation className="icon" />
              <span className="ms-3">Yogikuti 3, Rupandehi, Nepal </span>
            </div>
            <div>
              <BsTelephoneFill className="icon" />
              <span className="ms-3">+977-9812345678, 071-123456 </span>
            </div>
          </div>
          <div className="contact__map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3533.731723286103!2d83.46036033488767!3d27.663770799999988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3996857eac033a47%3A0xb45d8cbf5d94a5d3!2sHotel%20Pauwa%20Yogikuti%20Butwal!5e0!3m2!1sen!2snp!4v1658311106271!5m2!1sen!2snp"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          <Container>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Label>Full Name</Form.Label>
                  <Form.Group className="mb-4" controlId="formBasicEmail">
                    <Form.Control type="text" placeholder="Full Name" />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Label>Email Address</Form.Label>
                  <Form.Group className="mb-4" controlId="formBasicEmail">
                    <Form.Control type="email" placeholder="Email Address" />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Group className="mb-4" controlId="formBasicEmail">
                    <Form.Control type="text" placeholder="Phone Number" />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Label>Subject</Form.Label>
                  <Form.Group className="mb-4" controlId="formBasicEmail">
                    <Form.Control type="text" placeholder="Subject" />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Label>Message</Form.Label>
                  <Form.Group className="mb-4" controlId="formBasicEmail">
                    <Form.Control
                      as="textarea"
                      placeholder="Type your message"
                      rows={5}
                    />{" "}
                  </Form.Group>
                </Col>
              </Row>
              <div style={{ textAlign: "center" }}>
                <button className="btonn bton--lg bton--ghost">
                  Send Message{" "}
                </button>
              </div>
            </Form>
          </Container>
        </Container>
      </div>
    </>
  );
};

export default Contact;
